import React from 'react'
import { FaStar } from 'react-icons/fa'

const reviews = [
  {
    name: 'Aryan Sharma',
    institution: 'Chandigarh University',
    stars: 4,
    comment: 'Good and knowledgeable sessions.'
  },
  {
    name: 'Aditya Kumar',
    institution: 'Noida International University, (BCA)',
    stars: 5,
    comment: 'The internship program went really well and it was really good. The mentors were really good and knowledgeable. I fully satisfied and had a good experience with this Internship program with the Interns Elite.'
  },
  {
    name: 'Priya Arya',
    institution: 'Guru Nanak Dev University Regional Campus Gurdaspur',
    stars: 4,
    comment: 'Conclusion is the way they guided us , its time taking but growth matters. Personally i am delighted to say  i had good experience.'
  },
  {
    name: 'Kushal Garg',
    institution: 'Delhi University',
    stars: 5,
    comment: 'Experience with the team internsilite was very amazing, Every session with the mentor teaches a new thing and valuable point.'
  },
  {
    name: 'Manisha Tejbahadur Kurmi',
    institution: 'Shivajirao s. Jondhale College of Engineering, Delhi University',
    stars: 5,
    comment: 'Teacher is very helping and they have a lot of knowledge about autocad. They are trying to clear every single doubt of student.'
  },
  {
    name: 'Abhijeet Singh Rawat',
    institution: 'Graphic Era Hill University',
    stars: 4,
    comment: 'I feel glad to get such a huge amount of knowledge and got to learn so many things which are new for me and give such a wonderful experience for my whole upcoming life.. thank u and i fell pleasure to be the part of this program.'
  }
];

function AC_Review_Program_Page() {
  return (
    <div>
      <div className='container'>
        <div className='row d-sm-block d-md-none'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
            <div className='text-center review_component_text'>
              <h2 className='display-5 pb-2'>Testimonial</h2>
              <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>
        <div className='row'>
          <div className='col-md-4 pt-5'>
            <div className='Program_review_comp'>
              <div className='mt-5 px-5 review_component_text'>
                <h2 className='pt-5 display-6'>Hear What Our Students Say</h2>
                <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
              </div>
            </div>
          </div>
          <div className='col-md-8'>
            <div className='row'>
              {reviews.map((review, index) => (
                <div key={index} className={`col-md-${index % 2 === 0 ? '5' : '7'} card`}>
                  <div className='card-body'>
                    <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                    <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institution}</h6>
                    <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                      {[...Array(5)].map((_, i) => (
                        <li key={i}>
                          <FaStar color={i < review.stars ? "gold" : undefined}/>
                        </li>
                      ))}
                    </ul>
                    <p className='Review_not_copy'>
                      <i className='fas fa-quote-left pe-2'></i>{review.comment}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AC_Review_Program_Page
